import BlockContent from '@sanity/block-content-to-react';
import Cta from '@/components/ui/buttons/Cta';
import React from 'react';
import { imageUrlBuilder, portableTextSerializer } from '@/utils/helpers';
import styles from './styles.module.css';
import Image from 'next/image';

interface CapabilityProps {
  heading?: string;
  cta?: Record<string, unknown>;
  description?: string;
  textContent?: Record<string, unknown>[];
  image?: Record<string, unknown>;
  bgColor?: {
    hex: string;
  };
  textColor?: {
    hex: string;
  };
  underline: {
    color?: {
      hex: string;
    };
    width?: number;
  };
}

const Capability: React.FC<CapabilityProps> = ({
  heading,
  bgColor,
  textContent,
  cta,
  description,
  textColor,
  underline,
  image,
}) => {
  const wrapperRef = React.useRef(null);

  React.useEffect(() => {
    if (bgColor?.hex) {
      wrapperRef.current.style.setProperty('--bgColor', `${bgColor.hex}`);
    }
    if (textColor?.hex) {
      wrapperRef.current.style.setProperty('--fontColor', `${textColor.hex}`);
    }
    if (underline?.width) {
      wrapperRef.current.style.setProperty('--underlineWith', `${underline?.width}%`);
    }
    if (underline?.color) {
      wrapperRef.current.style.setProperty('--underlineColor', `${underline?.color.hex}`);
    }
  }, [wrapperRef, bgColor, textColor, underline]);

  return (
    <div ref={wrapperRef} className={styles.wrapper}>
      <div className={styles.capability}>
        <div className={styles.titles}>
          {image && (
            <div className={styles.imageWrapper}>
              <Image
                src={imageUrlBuilder.image(image.asset).auto('format').quality(80).url()}
                alt={heading || 'Capability Image'}
                width={100}
                height={100}
              />
            </div>
          )}
          <div className={styles.textWrapper}>
            <h3 className={styles.heading}>{heading}</h3>
            <p className={styles.textTitles}>{description}</p>
            <hr className={styles.underrline} />
          </div>
        </div>
        <div className={styles.content}>
          {textContent && (
            <div className={styles.textContent}>
              <BlockContent blocks={textContent} serializers={portableTextSerializer} />
            </div>
          )}
          {cta && (
            <Cta to={(cta as { route: string }).route} type="link">
              {(cta as { title: string }).title}
            </Cta>
          )}
        </div>
      </div>
    </div>
  );
};

export default Capability;
